module.exports = __webpack_public_path__ + "media/images/e-bilet/about/baggage-7b61a391ff7b359c7efddfcf03bb8947.svg";